import { useEffect } from "react";
import { useQueryClient } from "@tanstack/react-query";
import { storedToken } from "@common/api";
import { reportPlay } from "../library/playtime";
import { queryKeys } from "../library/queries";
import { desktop } from "./desktop";

/**
 * Play time for games in their own windows: the game process counts active
 * seconds and the app passes them on; this adds them to the signed-in
 * account, as the web player does for its own games.
 */
export default function DesktopPlaytime() {
  const queryClient = useQueryClient();
  useEffect(() => {
    let stop = () => {};
    desktop
      .onPlayed(({ name, system }, seconds) => {
        if (!storedToken()) return;
        reportPlay(name, system, seconds)
          .then(() => queryClient.invalidateQueries({ queryKey: queryKeys.playtime }))
          .catch(() => {});
      })
      .then((unlisten) => {
        stop = unlisten;
      });
    return () => stop();
  }, [queryClient]);
  return null;
}
